/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-namespace */
/* eslint-disable react/require-default-props */
import React from 'react'
import * as Styled from './ButtonDifmWmo.css'

type ButtonDifmWmoProps = {
  id?: string,
  icon?: React.ReactNode
  label?: React.ReactNode
  isSelected?: boolean,
  onClick?: () => void,
  dataTestId?: string
}

const ButtonDifmWmo: React.FC<ButtonDifmWmoProps> = ({
  id = '', icon = null, label, isSelected = false, onClick, dataTestId = '',
}) => (
  <Styled.Button
    id={id}
    datatest-id={dataTestId}
    isSelected={isSelected}
    onClick={onClick}
  >
    {icon && <Styled.ButtonIcon>{icon}</Styled.ButtonIcon>}
    {label}
  </Styled.Button>
)

export default ButtonDifmWmo
